import { CL_COUNTRIES } from "@/apps/credit-line/types/cl_countries";
import {
  LegacyCODocService,
  LegacyIMCDocService,
  LegacyMXDocService,
} from "@/apps/credit-line/services/multi-country/legacy-multi-country-doc.service";
import { IContractData } from "@/apps/credit-line/models/IContractData";

/*
 * @deprecated getCountryDocs helper is deprecated and
 * will be removed in the future
 * when PJO implements the ConsumerSettingsService.
 * */
export const getCountryDocs = (
  country: CL_COUNTRIES,
  contractData: IContractData
): LegacyIMCDocService | null => {
  switch (country) {
    case CL_COUNTRIES.MX:
      return new LegacyMXDocService(contractData);
    case CL_COUNTRIES.CO:
      return new LegacyCODocService(contractData);
    default:
      return new LegacyMXDocService(contractData);
  }
};
